import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class CookieDisclaimer extends PureComponent {
  static propTypes = {
    text: PropTypes.string.isRequired,
    link: PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
    closeHandler: PropTypes.func.isRequired,
  };

  render() {
    const { text, link, closeHandler } = this.props;
    return (
      <div className="cd-cookieDisclaimer">
        <div className="cd-cookieDisclaimer__wrapper">
          <span className="cd-cookieDisclaimer__message">
            { text } <a className="cd-cookieDisclaimer__link" href={link.href}>{link.label}</a>
          </span>
          <button
            className="cd-cookieDisclaimer__close"
            label="Close"
            onClick={closeHandler}
          />
        </div>
      </div>
    );
  }
}
